import { render, staticRenderFns } from "./factory-add-or-update.vue?vue&type=template&id=224fc44e"
import script from "./factory-add-or-update.vue?vue&type=script&lang=js"
export * from "./factory-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports